<template>
  <nav class="nav">
      <div class="control">
        <div class="logo">
          <img src="/images/logo@2x.png" alt="">
        </div>
        <div class="hamburger-btn" @click="toggleDrawer">
          <el-icon :size="24">
            <Expand v-if="drawerVisible" />
            <Fold v-else/>
          </el-icon>
        </div>
        <div class="right">
          <!-- <div class="menu">
            <ul>
              <li 
                v-for="(item, index) in navList" 
                :key="index" 
                :class="getParentRouteName == item.name ? 'active': ''"
                @click="goPage(item)">{{ item.meta.title }}</li>
            </ul>
          </div>
          <BaseSearch></BaseSearch> -->
        </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Expand, Fold } from '@element-plus/icons-vue'
import { navPages } from "@/router/index.js"


// 路由对象
const router = useRouter()
// 获取当前路由对象
const route = useRoute()

const navList = ref([
  ...navPages,
]);

// 获取当前路由对象
const getParentRouteName = computed(() => {
  let routeName = route.name == 'DynamicDetail' ? 'Dynamic' : route.name;
  return routeName;
})

// 控制抽屉显示/隐藏
const drawerVisible = ref(false)

// 打开抽屉
const toggleDrawer = () => {
  drawerVisible.value = !drawerVisible.value
}

function scrollToHash(hash) {
  console.log(hash);
  
  if (hash) {
    const element = document.querySelector('#'+hash);
    if (element) {
      // 1. 获取顶部固定元素的高度（头部导航的高度）
      const offset = 125; 
      // 2. 计算目标元素距离文档顶部的总距离
      const elementPosition = element.offsetTop;
      // 3. 计算需要滚动到的位置
      const offsetPosition = elementPosition - offset;
      // 4. 执行平滑滚动
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}
// 菜单选择事件
const onMenuSelect = (name) => {
  const item = navList.value.find(item => item.name == name);
  scrollToHash(item.name);
  setTimeout(() => {
    drawerVisible.value = false
  }, 500)
}

function goPage(page) {
  router.push({
    name: page.name,
  })
}

</script>

<style lang="scss" scoped>
.logo img{
  width: 4.25rem;
  margin-left: -0.5rem;
  margin-top: -0.05rem;
}
.nav {
  height: 0.8rem;
  background: #072C63;
  color: #fff;
  .control {
    display: flex;
    justify-content: space-between;
  }
  .menu ul {
    padding-top: 0.12rem;
    display: flex;
    li {
      color: #D1DAF7;
      padding: 0 0.16rem;
      line-height: 0.64rem;
      font-size: 0.16rem;
      cursor: pointer;
      white-space: nowrap;
    }
    li:hover{
      color: #fff;
      border-bottom: 0.04rem solid #2787FD;
    }
    li.active {
      color: #fff;
      border-bottom: 0.4rem solid #2787FD;
    }
  }

  .right {
    display: flex;
  }
}
</style>
<style lang="scss" scoped>
.hamburger-btn {
  display: none;
}
.side-menu {
  background: none;
  border-right: none;
  &:deep(li) {
    color: #fff;
  }
  &:deep(.el-menu-item) {
    padding: 0 0.05rem !important;
    height: 0.46rem;
    line-height: 0.46rem;
    background: none !important;
    span {
      display: block;
      height: 100%;
      box-sizing: border-box;
      border-bottom: 0.04rem solid transparent;
    }
  }
  &:deep(.el-menu-item.is-active) {
    color: #2787FD;
    background: none !important;
    span {
      border-color: #2787FD;
    }
  }
}

/* 平板或小屏设备 */
@media (max-width: 768px) {
  .nav {
    height: auto;
    position: relative;
  }
  .nav .control {
    display: block;
    padding-bottom: 0.1rem;
    .logo{
      img {
        width: auto;
        height: 0.69rem;
        margin: 0;
        margin-left: -0.36rem;
      }
    }
    .hamburger-btn {
      display: block;
      position: absolute;
      right: 0.1rem;
      top: 0.2rem;
    }
    .right{
      display: flex;
      width: 100%;
      .menu {
        display: none;
      }
      &:deep(.BaseSearch) {
        width: 100%;
        margin: 0;
        padding: 0;
        height: 0.4rem;
        .btn {
          line-height: 0.4rem;
        }
        .search {
          flex: 1;
        }
      }
    }
    
  }
}

</style>
<style lang="scss">
.page-container-mobile {
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 50;
  }
}
</style>